import axios from "axios";
import { BASE_URL_API } from "../Constants";

const mobileApiInstance = axios.create({
  baseURL: `${BASE_URL_API}/mobileapis`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to get my groups as events list
async function getMyGroups(params) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");

    const config = {
      method: "get",
      url: `/get-my-groups_v2?${params}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${AUTH_TOKEN}`,
      },
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get group inof as event details
async function getGroupInfo(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-group-info_v2?group_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get group posts as event posts
async function getGroupPosts(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-group-posts?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get post comments
async function getPostComments(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-post-comments?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to like unline post
async function likeUnlikePost(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/like-unlike-post?post_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to add text commment
async function addComment(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/add-comment?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get group members
async function getEventCheckedInListV2(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `get_event_checkedin_list_v2?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to check in event
async function eventCheckIn(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/event_checkin_v2?group_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to check out event
async function eventCheckOut(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/event_checkout_v2?group_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api to add new post
async function addPost(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/add-post?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api to edit post
async function postInfo(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/post-info?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to delete post
async function deletePost(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/delete-post?post_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api to upload image
async function uploadImage(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/upload-image`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api to edit post
async function commentInfo(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/comment-info?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to delete post
async function deleteComment(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/delete-comment?comment_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get event attachments
async function getEventAttachments(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-event-attachments?group_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// add event attachmenet
async function addEventAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/add-event-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// update event attachmenet
async function updateEventAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/update-event-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// delete event attachmenet
async function deleteEventAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "delete",
      url: `/delete-event-attachment?${data}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to create shared link
async function createSharedLink(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/create-shared-link?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to create group
async function createGroup(queryPrams, formData) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/create-group_v2?${queryPrams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: formData,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to edit group
async function editGroup(queryPrams, formData) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/group-info_v2?${queryPrams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: formData,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to delete group
async function deleteGroup(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/delete-group_v2?group_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get owner events
async function getOwnerEvents(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-owner-events?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get participated events
async function getParticipatedEvents(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-participated-events?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get owner events
async function getEventPaymentIntent(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-event-payment-intent?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get filters
async function getFilters() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-filters`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to create event wavier
async function createWavier(formData) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: `/create-wavier`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: formData,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

const PostServices = {
  getMyGroups,
  getGroupInfo,
  getGroupPosts,
  getPostComments,
  likeUnlikePost,
  addComment,
  getEventCheckedInListV2,
  eventCheckIn,
  eventCheckOut,
  addPost,
  postInfo,
  deletePost,
  uploadImage,
  commentInfo,
  deleteComment,
  getEventAttachments,
  addEventAttachment,
  updateEventAttachment,
  deleteEventAttachment,
  createSharedLink,
  createGroup,
  editGroup,
  deleteGroup,
  getOwnerEvents,
  getParticipatedEvents,
  getEventPaymentIntent,
  getFilters,
  createWavier,
};

export default PostServices;
